<template>
    <div class="video-input-container">
        <input ref="fileInput" class="file-input" type="file" @change="onFileChange" :accept="mimeTypes"/>
        <div v-ripple @click="pickFile" class="btn-container">
            <slot name="button">
                <v-btn>Seleccionar archivo</v-btn>
            </slot>
        </div>
    </div>
</template>

<script>
import {storageRef, storage} from '@/utils/Firebase'

export default {
    name: "FileUploader",
    props: {
        relativePath: {
            type: String,
            default: 'files'
        },
        mimeTypes: {
            type: String,
            default: 'video/*'
        },
        limitSize: {
            type: [String, Number],
            default: null,
        }
    },
    data() {
        return {
            progress: 0,
            file: null,
            megabyte: 1048576,
        }
    },
    methods: {
        reset() {
            const vm = this
            vm.file = null
            vm.$refs.fileInput.value = null
            vm.progress = 0
        },
        pickFile() {
            const vm = this
            vm.$refs.fileInput.click()
        },
        onFileChange(evt) {
            const vm = this
            const file = evt.target.files[0]

            if (vm.limitSize && file.size > (vm.limitSize * vm.megabyte))
                return vm.toast(vm.$t('common.limit_file', {num: vm.limitSize}), 'error')

            vm.file = file
            vm.$emit('change', {
                name: vm.file.name,
                url: URL.createObjectURL(vm.file)
            })
        },
        async upload() {
            const vm = this
            const file = vm.file
            if (!file) return console.log('no file selected')
            const savePath = `/${vm.currentUser.uid}/${vm.relativePath}/${vm.$moment().unix()}-${file.name}`
            let uploadTask = await storageRef.child(savePath).put(file)
            vm.$emit('success', {downloadURL: await uploadTask.ref.getDownloadURL(), savePath: savePath})
        },
    }
}
</script>

<style scoped>
.video-input-container {
    display: inline-block;
}

.btn-container {
    display: inline-block;
}

.file-input {
    display: none;
}
</style>